import React from "react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/effects/Reveal";
import { T } from "@/context/SiteContent";
import { BACKEND_URL } from "@/config";

const resolveImg = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const Blog = ({ posts }) => (
  <section id="blog" className="section relative">
    <div className="section-tint" />
    <div className="container">
      <Reveal>
        <p className="eyebrow mb-4"><T k="blog.eyebrow" fallback="The Field Journal" /></p>
        <h2 className="font-serif text-5xl md:text-6xl tracking-tight max-w-3xl"><T k="blog.headline" fallback="Bayou-wisdom for Disney families." /></h2>
      </Reveal>
      <div className="mt-14 grid md:grid-cols-3 gap-6">
        {posts.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08}>
            <Link to={`/journal/${p.slug || p.id}`} className="block h-full" data-testid={`blog-card-link-${p.slug || p.id}`}>
              <article className="product-card cursor-pointer group h-full" data-testid={`blog-${p.id}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={resolveImg(p.image)} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#040A0F] via-transparent to-transparent" />
                </div>
                <div className="p-6">
                  <div className="text-xs text-[#B9C8D5] mb-2">{format(new Date(p.date), "MMM d, yyyy")} · {p.read_time}</div>
                  <h3 className="font-serif text-2xl leading-tight group-hover:text-[#FFD166] transition-colors">{p.title}</h3>
                  <p className="mt-3 text-sm text-[#B9C8D5]">{p.excerpt}</p>
                  <div className="mt-4 text-[#FFD166] text-sm inline-flex items-center gap-1">Read <ArrowRight className="w-3.5 h-3.5" /></div>
                </div>
              </article>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
